import { IPropertyType } from '@network/models/property-type.model'
import { TypeOrNull } from '@network/models/common.model'
import { IOvertimePolicy } from '@network/models/overtime-policy.model'
import { IBaseGetParams } from './global.model'
import { IBaseReducer } from './base-reducer.model'
// TODO add optional params to interfaces

export enum PROPERTY_STATUS {
  PENDING,
  APPROVED,
}

export enum PROPERTY_STATUS_LABEL {
  PENDING = 'Pending',
  APPROVED = 'Approved',
}

export enum PROPERTY_SETTING_STATUS {
  INACTIVE,
  ACTIVE,
}

export interface IPropertyIncludeParams {
  include?:
    | {
        business?: Record<any, any>
        property_type?: Record<any, any>
        property_category?: Record<any, any>
        active_overtime_policy?: Record<any, any>
      }
    | (
        | 'business'
        | 'property_type'
        | 'property_category'
        | 'active_overtime_policy'
      )[]
}
export interface IProperty {
  id: number
  owner_id: number
  business_id: number
  property_type_id: number
  property_category_id: number
  state_id: number
  county_id: number
  city: number
  invoice_group_id: number
  name: string
  description: string
  email: string
  phone: string
  rating: number
  code?: string
  wc_code?: string
  has_tax: boolean
  fixed_time: boolean
  commission_percent: number
  timezone: string
  address: string
  latitude: number
  longitude: number
  zip: number
  timetracker_clock_in_only: boolean
  credits: number
  status: PROPERTY_STATUS
  regions: any[]
  arrival_instructions: string
  arrival_instructions_rich_text: string
  arrival_instructions_attachment_id: number
  property_type?: IPropertyType
  active_overtime_policy?: TypeOrNull<IOvertimePolicy>
  property_setting: IPropertySetting

  /**
   * Start Deprecated
   */

  owner_full_name: string
  owner_company_name: string
  business_industry_id: number
  property_type_name: string
  property_category_name: string
  credits_amount: string
  business_billing_type_id: string
  suggested_pay_rate: number
  min_wage: string
  /**
   * End Deprecated
   */
}

export interface IPropertySetting {
  id: number
  property_id: number
  geofencing_enabled: boolean
  geofencing_web_app_enabled?: boolean
  geofencing_mobile_app_enabled?: boolean
  radius_miles: number
  status?: PROPERTY_SETTING_STATUS
  onsite_tracking_enabled?: boolean
}

export type IGetPropertyParams = IBaseGetParams & IPropertyIncludeParams

export interface IGetPropertiesParamsBase extends IBaseGetParams {
  owner_id?: number
  business_id?: number
  property_type_id?: number
  property_category_id?: number
  country_id?: number
  state_id?: number
  county_id?: number
  city_id?: number
  employee_id?: number
  invoice_group_id?: number
  invoice_id?: number
  status?: PROPERTY_STATUS
  disable_employee_id?: boolean
  blocked_user_id?: number
  unblocked_user_id?: number
  property_id?: number
  order_by_property_id?: number
}

export type IGetPropertiesParams = IGetPropertiesParamsBase &
  IPropertyIncludeParams

export interface IPostPropertyParamsBase {
  owner_id: number
  business_id: number
  property_type_id: number
  name: string
  adress: string
  latitude: string
  longitude: string
  zip: string
  property_category?: string
  country_id?: number
  state_id?: number
  county_id?: number
  city_id?: number
  description?: string
  email?: string
  phone?: string
  code?: string
  wc_code?: string
  has_tax?: boolean
  fixed_time?: boolean
  commision_percent?: number
  properties?: number[]
  timetracker_clock_in_only?: boolean
  invoice_group_id?: number
  credits?: number
  status?: PROPERTY_STATUS
}

export type IPostPropertyParams = IPostPropertyParamsBase &
  IPropertyIncludeParams

export interface IPutPropertyParamsBase {
  owner_id?: number
  business_id?: number
  property_type_id?: number
  name?: string
  adress?: string
  latitude?: number
  longitude?: number
  zip?: string
  property_category?: string
  country_id?: number
  state_id?: number
  county_id?: number
  city_id?: number
  description?: string
  email?: string
  phone?: string
  code?: string
  wc_code?: string
  has_tax?: boolean
  fixed_time?: boolean
  commision_percent?: number
  properties?: number[]
  timetracker_clock_in_only?: boolean
  invoice_group_id?: number
  credits?: number
  status?: PROPERTY_STATUS
  arrival_instructions?: string
}

export type IPutPropertyParams = IPutPropertyParamsBase & IPropertyIncludeParams

export interface IAddressInfo {
  state_id?: number
  county_id?: number
}

export interface IGetPropertyAddressInfo {
  address?: string
  zip?: string
}

export interface IPropertyReducer extends IBaseReducer<IProperty> {}

export interface IPropertiesReducer extends IBaseReducer<IProperty[]> {
  initialFetch?: boolean
}
